import React from 'react';
import { RouteObject } from 'react-router-dom';
import { grilleTarifaireBasePath, grilleTarifairePath } from './constants';
import { GrilleTarifaireRoot } from './grilleTarifaireRoot';
import { GrilleTarifaireRoute } from './page';

export const grilleTarifaireRouter: RouteObject = {
    path: grilleTarifaireBasePath,
    element: <GrilleTarifaireRoot />,
    handle: { title: 'Grille Tarifaire' },
    children: [
        {
            path: grilleTarifairePath,
            element: <GrilleTarifaireRoute />,
            handle: { title: 'Grille Tarifaire' },
        },
    ],
};
